import { FC, ReactNode, useMemo } from "react";
import ReactSelect from "react-select";
import { useRouter } from "next/router";
import { ProductVariationsSearchGetSortEnum } from "@/web-client";
import { ReactSelectDefaultStyles } from "@/consts/ReactSelect";
import { SearchQueryParameterController } from "@/hooks/useSearchQueryParameter";
import { ProductSearchQueryParameter } from "@/types/ProductSearchQueryParameter";
import { formatSortByProductVariation } from "@/utils/formatSortByProductVariation";
import useDevice from "@/hooks/useDevice";

interface Props {
  selectedSort?: ProductVariationsSearchGetSortEnum;
  queryController: SearchQueryParameterController<ProductSearchQueryParameter>;
}

export const ProductSortPulldown: FC<Props> = ({ selectedSort }) => {
  const router = useRouter();
  const { query } = router;
  const { isSp } = useDevice();

  const options = useMemo(() => {
    return [
      ProductVariationsSearchGetSortEnum.Recommend,
      ProductVariationsSearchGetSortEnum.PriceAsc,
      ProductVariationsSearchGetSortEnum.PriceDesc,
      ProductVariationsSearchGetSortEnum.SampleRequestsRecentDesc,
      ProductVariationsSearchGetSortEnum.SampleRequestsTotalDesc,
    ].map((value) => {
      return {
        value,
        label: (
          <span className="flex gap-4 items-center whitespace-nowrap leading-none">
            {formatSortByProductVariation(value)}
          </span>
        ),
      };
    });
  }, []);

  const defaultOption = useMemo<
    { value: ProductVariationsSearchGetSortEnum; label: ReactNode } | undefined
  >(() => {
    // なにも選択されていない場合はRecommendを選択
    if (!selectedSort) {
      return options[0];
    }

    return options.find(({ value }) => value === selectedSort);
  }, [options, selectedSort]);

  return (
    <ReactSelect
      isMulti={false}
      isSearchable={false}
      menuPosition="fixed"
      menuPlacement="bottom"
      onChange={(option) => {
        router.push({
          query: {
            ...query,
            sort: option?.value,
          },
        });
      }}
      value={defaultOption}
      options={options}
      styles={{
        ...ReactSelectDefaultStyles(32, isSp ? 12 : 14, isSp ? 160 : 200),
      }}
    />
  );
};
